<template>
  <div class="flex flex-col min-h-screen w-full bg-white">
    <cabecera-gob-mx />
    <main class="flex-1 p-10 mx-auto max-w-5xl space-y-5">
      <h1 class="text-5xl font-bold pt-20">
        Política de privacidad
      </h1>
      <p>
        La presente Política de Privacidad establece los términos en que Centro Geo usa y protege la información que es proporcionada por sus usuarios al momento de utilizar la aplicación móvil Apporta (en adelante, la app). Centro Geo está comprometido con la seguridad de los datos de sus usuarios. Cuando le pedimos llenar los campos de información personal con la cual usted pueda ser identificado, lo hacemos asegurando que sólo se empleará de acuerdo con los términos de este documento. Sin embargo esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que le recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de acuerdo con dichos cambios.
      </p>
      <h2 class="text-3xl font-bold pt-5">
        Información que es recogida
      </h2>
      <p>
        La app podrá recoger información personal por ejemplo: Nombre, información de contacto como su dirección de correo electrónico, así como su posición geográfica.
      </p>
      <h2 class="text-3xl font-bold pt-5">
        Permisos de la aplicación
      </h2>
      <p>
        La app requiere de ciertos permisos para su correcto funcionamiento, los cuales deben ser concedidos por el usuario. Estos permisos son:
      </p>
      <ul>
        <li><b>Acceso al almacenamiento:</b> Para acceder a imágenes guardadas en la galería y poder subirlas al servidor.</li>
        <li><b>Acceso al micrófono y cámara:</b> Para poder grabar audio y video que puedar servir de evidencia de registros.</li>
        <li><b>Acceso al GPS:</b> Para conocer la ubicación de donde se encuentre un registro.</li>
      </ul>
      <h2 class="text-3xl font-bold pt-5">
        Uso de la información recogida
      </h2>
      <p>La App emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios.</p>
      <p>Centro Geo está altamente comprometido para cumplir con el compromiso de mantener su información segura. Regularmente se monitorea la seguridad para asegurar que no existan accesos no autorizados.</p>
      <p>Centro Geo no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento.</p>
      <p>Centro Geo se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento.</p>
    </main>
    <piedepagina-gob-mx />
  </div>
</template>

<style scoped>
</style>

<script>
import CabeceraGobMx from "./CabeceraGobMx.vue";
import PiedepaginaGobMx from "./PiedepaginaGobMx.vue";

export default {
  data() {
    return {};
  },
  components: {
    CabeceraGobMx,
    PiedepaginaGobMx,
  },
  computed: {},
  methods: {},
};
</script>
